enum BlockMode {
  /* store rendered html into blocks */
  OUTPUT,
  /* output rendered html directly */
  STORE
}

export default BlockMode
